import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'konfig/'

export default {


    getPelenKonfig() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    pobierzObiektKonfigu(id){
        return axios({
            method: 'get',
            url: URL + id,
        });
    },


    pobierzObiektySekcji(sekcja){
        return axios({
            url: URL + 'getSekcja',
            method: 'post',
            data: JSON.stringify({
                "sekcja": sekcja,
            }),
        });
    },

    dodajDoKonfigu(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    pobierzPojedynczyObiektZConfigu(sekcja,pozycja){
        return axios(
            {
                url: URL + 'getOne',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": sekcja,
                    "pozycja": pozycja
                }),
            }
        )
    },

    pobierzObiektBiletow(){
        return axios(
            {
                url: URL + 'getOne',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": "Bilety",
                    "pozycja": "Zakup ile godzin przed"
                }),
            }
        )
    },

    pobierzWartoscBiletow(){
        return axios(
            {
                url: URL + 'getWartosc',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": "Bilety",
                    "pozycja": "Zakup ile godzin przed"
                }),
            }
        )
    },

    pobierzObiektStartRozkladu(){
        return axios(
            {
                url: URL + 'getOne',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": "Rozkład jazdy",
                    "pozycja": "Data od"
                }),
            }
        )
    },

    pobierzWartoscStartRozkladu(){
        return axios(
            {
                url: URL + 'getWartosc',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": "Rozkład jazdy",
                    "pozycja": "Data od"
                }),
            }
        )
    },

    pobierzObiektKoniecRozkladu(){
        return axios(
            {
                url: URL + 'getOne',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": "Rozkład jazdy",
                    "pozycja": "Data do"
                }),
            }
        )
    },

    pobierzWartoscKoniecRozkladu(){
        return axios(
            {
                url: URL + 'getWartosc',
                method: 'post',
                data: JSON.stringify({
                    "sekcja": "Rozkład jazdy",
                    "pozycja": "Data do"
                }),
            }
        )
    },

    ustawWartosc(id,data){
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    }



}


// WEBPACK FOOTER //
// ./src/modules/administracja/konfiguracja/KonfiguracjaService.js